if (!customElements.get('tabs-nav')) {
  class TabsNav extends HTMLElement {
    constructor() {
      super();
    }

    setOffset() {
      const styles = getComputedStyle(document.documentElement);
      const offsetHeader = styles.getPropertyValue(
        '--header-offset-top'
      );
      const offsetAnnouncement = styles.getPropertyValue(
        '--announcement-bar-top-position'
      );

      this.offset =
        Number(offsetHeader.replace('px', '')) +
        Number(offsetAnnouncement.replace('px', ''));
    }

    connectedCallback() {
      this.setOffset();

      this.tabsBody = this.closest('.shopify-section').querySelector(
        '.js-tabs-body'
      );

      this.addEventListener('click', (event) => {
        event.preventDefault();

        const anchor = event.target.closest('a') || event.target;
        const href = anchor.getAttribute('href');
        if (!href) return;

        const target = this.tabsBody.querySelector(
          `[data-target="${href}"]`
        );
        if (!target) return;

        const active = this.tabsBody.querySelector('.is-active');
        if (active) active.classList.remove('is-active');

        const activeLink = this.querySelector('.is-active');
        if (activeLink) activeLink.classList.remove('is-active');

        anchor.classList.add('is-active');
        target.classList.add('is-active');

        target
          .querySelectorAll('.js-accordion-item')
          .forEach((item) => {
            if (item.calculateHeight) item.calculateHeight();
          });

        window.scrollTo({
          top:
            this.closest('.shopify-section').offsetTop - this.offset,
          behavior: 'smooth',
        });
      });
    }
  }
  customElements.define('tabs-nav', TabsNav);
}
